import { reportDemoModeAtom } from '@/global-store';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Alert } from '@eye-able/ui';

function NoSaveInDemoBanner({ className }: { className?: string }) {
  const { t } = useTranslation();
  const [reportDemoMode] = useAtom(reportDemoModeAtom);

  if (!reportDemoMode) {
    return null;
  }

  return (
    <Alert variant='warning' className={className}>
      {t('noSaveInDemoMode')}
    </Alert>
  );
}

export default NoSaveInDemoBanner;
